// ProjectTitle.js
import React from "react";

export default function ProjectTitle({ prj, onEditClick }) {
  return (
    <div className="project-title-container">
      <div className="project-header">
        <div className="project-title">
          <h2>{prj.nome}</h2>
          <div className="status-badges">
            <span className="status-badge status-settore">{prj.categoria}</span>
            <span
              className={`status-badge status-${
                prj.completato ? "completato" : "aperto"
              }`}
            >
              {prj.completato ? "Completato" : "Aperto"}
            </span>
          </div>
        </div>
        {onEditClick && (
          <button
            className="edit-button"
            onClick={onEditClick}
            title="Modifica progetto"
          >
            <i className="material-icons">edit</i>
          </button>
        )}
      </div>
      <div className="project-details">
        <p className="project-subtitle">
          {prj.tipoProject === "cantiere" ? "Cantiere" : "Settore"}
        </p>
      </div>
    </div>
  );
}
